
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 6.404v.913h1.714c.707 0 1.286.615 1.286 1.368v10.947c0 .752-.579 1.368-1.286 1.368H7.286C6.579 21 6 20.384 6 19.632V8.685c0-.753.579-1.368 1.286-1.368H9v-.913h6zM15.844 2c.177 0 .321.153.321.342V4.95c0 .19-.144.343-.321.343H8.17c-.178 0-.322-.154-.322-.343V2.342c0-.189.144-.342.322-.342h7.674z","fill":"#008C89"}}),_c('rect',{attrs:{"x":"12","y":"10","width":"4","height":"9","rx":"1","fill":"#fff"}})])
          )
        }
      }
    